/* COLLAPSE — moteur d'animations + header fixe (sans dependance externe).
   Securite : si ce script ne s'execute pas, aucun contenu n'est masque. */
(function(){
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---------- Header : reellement fixe, quel que soit le parent ---------- */
  function fixHeader(){
    var grp = document.querySelector('.shopify-section-group-header-group');
    if (!grp) {
      var hc = document.getElementById('header-component');
      grp = hc ? (hc.closest('.shopify-section') || hc) : null;
    }
    if (!grp || grp.__clpFixed) { return; }
    grp.__clpFixed = true;

    var spacer = document.createElement('div');
    spacer.className = 'clp-hdr-spacer';
    if (grp.parentNode) { grp.parentNode.insertBefore(spacer, grp); }
    document.body.appendChild(grp);          /* sort de tout ancetre a overflow/transform */
    grp.classList.add('clp-hdr-fixed');

    function sync(){
      var h = grp.offsetHeight || 0;
      spacer.style.height = h + 'px';
      root.style.setProperty('--clp-hdr-h', h + 'px');
    }
    sync();
    addEventListener('resize', sync, {passive:true});
    setTimeout(sync, 400);
    setTimeout(sync, 1200);
    if (window.ResizeObserver) { new ResizeObserver(sync).observe(grp); }
  }
  if (document.readyState !== 'loading') { fixHeader(); }
  else { document.addEventListener('DOMContentLoaded', fixHeader); }

  function headerScroll(){
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    root.classList.toggle('clp-hdr-scrolled', y > 40);
  }
  headerScroll();
  addEventListener('scroll', headerScroll, {passive:true});

  if (REDUCED || !('IntersectionObserver' in window)) { return; }

  /* ---------- Selecteurs animes ---------- */
  var TEXT_SEL = [
    '.clp-c__sig','.clp-c__cat','.clp-c__drop','.clp-c__name','.clp-c__camp',
    '.clp-fond__sig','.clp-fond__cat','.clp-mf__t','.clp-archv__t','.clp-ap__t',
    '.clp-pinfo__coll','.clp-pinfo__title'
  ].join(',');

  var BLOCK_SEL = [
    '.clp-sq--iv','.clp-pcard','.clp-archv__c','.clp-mf__c','.clp-eq__hud',
    '.clp-cd__g','.clp-fond__link','.clp-ap__block',
    '.clp-pinfo__price','.clp-pinfo__intro','.clp-pinfo__rule','.clp-pform','.clp-acc',
    '.clp-gal__stage'
  ].join(',');

  /* Zones qui apparaissent en cendres (collapse-ash.js) : pas de second effet (fondu + flou) par-dessus,
     sinon les textes restent cachés jusqu'au défilement et l'effet cendre ne se voit pas. */
  var ASH_SEL = '.clp-drop .clp-sq--bk, .clp-mf, .clp-fond__h, .clp-prod .clp-pinfo';

  function inHero(el){ return !!el.closest('.clp-hero2'); }

  function tag(el, type){
    if (!el || el.hasAttribute('data-clp-a') || inHero(el) || el.closest(ASH_SEL)) { return; }
    el.setAttribute('data-clp-a', type);
    var p = el.parentElement;
    if (!p.__clpN) { p.__clpN = 0; }
    var i = p.__clpN++;
    if (i > 0) { el.style.setProperty('--clp-d', Math.min(i * 90, 450) + 'ms'); }
  }

  document.querySelectorAll(TEXT_SEL).forEach(function(el){ tag(el, 't'); });
  document.querySelectorAll(BLOCK_SEL).forEach(function(el){ tag(el, 'b'); });

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) { return; }
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});

  document.querySelectorAll('[data-clp-a]').forEach(function(el){ io.observe(el); });

  var gio = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) { return; }
      e.target.classList.add('is-in');
      gio.unobserve(e.target);
    });
  }, {threshold:0.35});

  document.querySelectorAll('.clp-gauge').forEach(function(el){ gio.observe(el); });

  root.classList.add('clp-anim');

  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      var vh = innerHeight;
      document.querySelectorAll('[data-clp-a], .clp-gauge').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) { el.classList.add('is-in'); }
      });
    });
  });

  document.addEventListener('shopify:section:load', function(){
    document.querySelectorAll('[data-clp-a], .clp-gauge').forEach(function(el){
      el.classList.add('is-in');
    });
  });
})();